import { Switch } from '@fluentui/react-components';
import { Map } from '@powerportalspro/react-maps';
import { useT } from '@powerportalspro/react';
import { useState } from 'react';

// Reuses the Blazor demo's localization keys (MapRecordsDemo) so both stacks share strings.
const STRINGS_BASE = 'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Maps.MapRecordsDemo';

const ACCOUNTS_FETCH_XML = `
<fetch>
  <entity name="account">
    <attribute name="name" />
    <attribute name="address1_city" />
    <attribute name="address1_stateorprovince" />
    <attribute name="telephone1" />
    <attribute name="industrycode" />
    <filter>
      <condition attribute="statecode" operator="eq" value="0" />
    </filter>
  </entity>
</fetch>`;

const CONTACTS_FETCH_XML = `
<fetch>
  <entity name="contact">
    <attribute name="fullname" />
    <attribute name="jobtitle" />
    <attribute name="parentcustomerid" />
    <attribute name="address1_city" />
    <attribute name="address1_stateorprovince" />
    <filter>
      <condition attribute="statecode" operator="eq" value="0" />
    </filter>
  </entity>
</fetch>`;

const UNITED_STATES = ['US'];

export function MapRecordsSample() {
  const t = useT();
  const [contacts, setContacts] = useState(false);
  const [lastClick, setLastClick] = useState<string | null>(null);
  const [found, setFound] = useState<string | null>(null);

  return (
    <>
      <Switch
        label={t(`${STRINGS_BASE}.show-contacts`)}
        checked={contacts}
        onChange={(_, data) => setContacts(data.checked)}
      />
      {/* Each row is placed at its address1_latitude and address1_longitude, named by the table's
          primary name; its popup shows the query's other columns, under its name linked to its
          record's page — the one the portal registers for its table with AddRecordPage. Accounts
          are colored by their relationship type, with a legend; the search box finds an address in
          the US. */}
      <Map
        fetchXml={contacts ? CONTACTS_FETCH_XML : ACCOUNTS_FETCH_XML}
        {...(contacts ? { recordColor: 'var(--colorPaletteBerryBackground3)' } : { colorColumn: 'customertypecode' })}
        showAddressSearch
        addressSearchCountries={UNITED_STATES}
        height="480px"
        onItemClick={({ item }) => setLastClick(item.title ?? null)}
        onAddressSelected={(place) => setFound(place?.label ?? null)}
      />
      <p style={{ marginTop: 12 }}>
        <strong>{t(`${STRINGS_BASE}.clicked-label`)}:</strong> {lastClick ?? t(`${STRINGS_BASE}.nothing-clicked`)}
        <br />
        <strong>{t(`${STRINGS_BASE}.found-label`)}:</strong> {found ?? t(`${STRINGS_BASE}.nothing-found`)}
      </p>
    </>
  );
}
